export default __webpack_public_path__ + "static/media/building-view.829e6e24.png";